import { SceneAssetRelation } from './../models/scene-asset-relations/SceneAssetRelation';
import { BaseAsset } from './../models/assets/baseAsset';

import { AlertController, NavController, LoadingController } from '@ionic/angular';
import { Injectable } from '@angular/core';
import { ApiVrEventService } from '../api-services/vr-event.api.service';
import { ApiVrEventAssetRelationService } from '../api-services/vr-event-asset-relation.api.service';
import { ApiQuestionResponseService } from './../api-services/question-response.api.service';
import { ApiAssetService } from './../api-services/asset.api.service';
import { ApiSceneAssetRelationService } from './../api-services/scene-asset-relation.api.service';
// import { SceneBackground } from './../models/sceneBackground';
// import { ApiSceneBackgroundService } from './../api-services/scene-background.api.service';
import { ApiSceneService } from './../api-services/scene.api.service';
import { AssetTypeService } from './asset-type.service';
import { Project } from './../models/project';
import { Scene } from '../models/Scene';
import { AssetInScene } from '../models/AssetInScene';
import { DeepCopyService } from './deep-copy.service';
import { AddProjectModalPage } from '../modals/add-project-modal/add-project-modal.page';
import { QuestionAsset } from '../models/assets/QuestionAsset';
import { Model3DSceneAssetRelation } from '../models/scene-asset-relations/model3DSceneAssetRelation';
import { AssetEvent } from '../models/vr-events/AssetEvent';
import { VrEvent } from '../models/vr-events/VrEvent';
import { VrEventAssetRelation } from '../models/vr-events/VrEventAssetRelation';
import { QuestionResponse } from '../models/assets/QuestionResponse';
import { promise } from 'protractor';
import { forkJoin } from 'rxjs';
import { SaveService } from './save.service';
import { ApiProjectService } from '../api-services/project.api.service';
import { GetAssetsFromDatabaseService } from './get-assets-from-database.service';
import { OutcomeActionService } from './outcome-action.service';
import { SceneEvent } from '../models/vr-events/SceneEvent';
import { ApiVrEventSceneRelationService } from '../api-services/vr-event-scene-relation.api.service';

@Injectable({
  providedIn: 'root'
})
export class CopyService {
   
    constructor(
        public sceneAPIService: ApiSceneService, 
        public assetAPIService: ApiAssetService,
        public sceneAssetRelationAPIService: ApiSceneAssetRelationService,
        public responseAPIService: ApiQuestionResponseService,
        public VrEventAssetRelationAPIService: ApiVrEventAssetRelationService,
        public VrEventSceneRelationAPIService: ApiVrEventSceneRelationService,
        public VrEventAPIService: ApiVrEventService,
        public projectAPIService: ApiProjectService,
        public deepCopyService: DeepCopyService,    
        public saveService: SaveService,
        public assetTypeService: AssetTypeService,
        public getAssetsFromDatabaseService: GetAssetsFromDatabaseService,
        public outcomeActionService: OutcomeActionService,
    ){
        //constructor
    }

    copyProject(project: Project): Promise<Project> {
        var copyProject: Project = this.deepCopyProject(project);
        return new Promise<Project>((resolve, reject) => {
            this.projectAPIService.addProject(copyProject).subscribe(projectFromDb => {
                var scenePromise = this.getScenesWithProjectId(project.projectId);
                scenePromise.then(scenes => {
                    var sceneIds = this.getIds(scenes, 'sceneId');
                    this.getAssetsFromDatabaseService.getAssetsWithSceneIds(sceneIds).then(async assetsInScene => {
                        for(let i: number = 0; i< scenes.length; i++){
                            let scene = scenes[i];
                            scene.projectId = projectFromDb.projectId;                      
                            await this.copyScene(scene, assetsInScene);
                        }                     
                        resolve(projectFromDb);
                    });
                })
                
            });
        });
    }

    getScenesWithProjectId(projectId): Promise<Scene[]> {
        return new Promise((resolve, reject) => {
            this.sceneAPIService.getScenesWithProjectId(projectId).subscribe(async scenesFromDb => {
                var scenes: any = scenesFromDb;
                await this.getScenesEvents(scenes);
                await this.getScenesOutcomeActions(scenes);
                resolve(scenes);
            });
        });
    }
    
    getScenesEvents(scenes: Scene[]): Promise<void> {
        var i: number = 0;
        return new Promise((resolve) => {
            scenes.forEach(async scene => {
                await this.getSceneEvents(scene);
                i++;
                if (i == scenes.length) {
                    resolve();
                }
            });
            if (scenes.length == 0) {
                resolve();
            }
        });
    }

    getScenesOutcomeActions(scenes: Scene[]) {
        var i: number = 0;
        return new Promise<void>((resolve) => {
            scenes.forEach(async scene => {
                await this.getSceneOutcomeActions(scene);
                i++;
                if (i == scenes.length) {
                    resolve();
                }
            });
            if (scenes.length == 0) {
                resolve();
            }
        });
    }

    getSceneEvents(scene): Promise<void> {
        var i: number = 0;
        return new Promise((resolve) => {
          scene.events = [];
          this.VrEventSceneRelationAPIService.getVrEventSceneRelationsWithSceneId(scene.sceneId).subscribe(VrEventSceneRelations => {
            VrEventSceneRelations.forEach((VrEventSceneRelation) => {
              this.VrEventAPIService.getVrEvent(VrEventSceneRelation.vrEventId).subscribe(VrEvent => {
                var eventForScene: SceneEvent = VrEvent as SceneEvent;
                eventForScene.sceneId = VrEventSceneRelation.sceneId;
                scene.events.push(eventForScene);
    
                i++;
                if (i == VrEventSceneRelations.length) {
                  resolve();
                }
              });
            });
            if (VrEventSceneRelations.length == 0) {
              resolve();
            }
          });
        });
    }

    getSceneOutcomeActions(scene: Scene) {
        return new Promise<void>((resolve) => {
          scene.outcomeActions = [];
          this.outcomeActionService.getOutcomeActionBySceneId(scene.sceneId).then(x => {
            if (x.length == 0) {
              resolve();
            } else {
              scene.outcomeActions = this.deepCopyService.deepCopy(x);
              resolve();
            }
          });
        });
    }

    copyScene(scene: Scene, assetsInScene: AssetInScene[])  : Promise<any>{  
        var assetsInSceneCopy = this.deepCopyService.deepCopy(assetsInScene);
        var promise = new Promise<any>((resolve, reject) => {
            var sceneForDb: Scene = this.deepCopyScene(scene);
            sceneForDb.projectId = scene.projectId;
            sceneForDb.sceneIndex = scene.sceneIndex;
           
            this.sceneAPIService.addScene(sceneForDb).subscribe(sceneResult => {
                sceneResult.events = sceneForDb.events;
                sceneResult.outcomeActions = sceneForDb.outcomeActions;
                var originalSceneAssets: AssetInScene[] = assetsInSceneCopy.filter(a => a.sceneAssetRelation.sceneId == scene.sceneId).filter(a => a.toBeRemoved == false);
                var dupAssets: AssetInScene[] = [];
                originalSceneAssets.forEach(originalAsset => {
                    var copyAsset: any = this.deepCopyAsset(originalAsset, sceneResult.sceneId, assetsInSceneCopy);                    
                    copyAsset.originalSceneAssetRelationId = originalAsset.sceneAssetRelation.sceneAssetRelationId;
                    copyAsset.newSceneAssetRelationId = copyAsset.sceneAssetRelation.sceneAssetRelationId;
                    dupAssets.push(copyAsset);
                    assetsInSceneCopy.push(copyAsset);
                });

                this.saveService.addOrUpdateAllSceneAssetRelations(dupAssets).then(async () => {
                    //update duplicated assets events and question rules
                    for(let i:number = 0; i<dupAssets.length; i++){
                        let assetInScene = dupAssets[i];
                        await this.copyAssetEventsOutcomeActionsAndQuestionRules(assetInScene, dupAssets);
                        if(assetInScene.assets){
                            for(let j:number = 0; j<assetInScene.assets.length; j++){
                                let assetInAssetInScene = assetInScene.assets[j];
                                await this.copyAssetEventsOutcomeActionsAndQuestionRules(assetInAssetInScene, dupAssets);
                            }
                        }
                    }
                    
                    sceneResult.events.forEach(event => {
                        event.sceneId = sceneResult.sceneId;

                        let newAsset = dupAssets.find((asset: any) => asset.originalSceneAssetRelationId == event.linkedContentId || asset.newSceneAssetRelationId == event.linkedContentId);
                        if(newAsset)
                            event.linkedContentId = newAsset.sceneAssetRelation.sceneAssetRelationId;
                    });

                    sceneResult.outcomeActions.forEach(outcomeAction => {
                        outcomeAction.sceneId = sceneResult.sceneId;
                    });

                    var sceneDTO ={
                        'assetsInScene' : dupAssets,
                        'scene': sceneResult
                    }
                    this.saveService.updateSceneEventsAndOutcomeActions(sceneResult).then(() => {
                        resolve(sceneDTO);
                    });
                });

                
            }); 
        });

        return promise;
    }

    copyAssetEventsOutcomeActionsAndQuestionRules(assetInScene: AssetInScene, dupAssets: AssetInScene[]): Promise<boolean>{        
        return new Promise<boolean>(async (resolve) => {
            let assetType = this.assetTypeService.getType(assetInScene.baseAsset.assetTypeId);
            if (assetInScene.events){
                for(let i: number = 0; i<assetInScene.events.length; i++){            
                    let event = assetInScene.events[i]                                ;
                    event.sceneAssetRelationId = assetInScene.sceneAssetRelation.sceneAssetRelationId;
    
                    let findAsset = dupAssets.find((dupAsset: any) => dupAsset.originalSceneAssetRelationId == event.linkedContentId || dupAsset.newSceneAssetRelationId == event.linkedContentId);
                    if(findAsset)
                        event.linkedContentId = findAsset.sceneAssetRelation.sceneAssetRelationId;
                    
                    let vrEventPromise = this.saveService.addVrEventToDbWithoutPromise(event);
                    await this.saveService.addVrEventAssetRelationToDb(event, vrEventPromise);
                }
            }
            if(assetInScene.outcomeActions){
                for(let i: number = 0; i<assetInScene.outcomeActions.length; i++){
                    let outcomeAction = assetInScene.outcomeActions[i];
                    outcomeAction.sceneAssetRelationId = assetInScene.sceneAssetRelation.sceneAssetRelationId;
                    await this.outcomeActionService.addOutcomesAction(outcomeAction);                    
                }
            }
            if (assetInScene.questionRules){
                for(let i: number = 0; i<assetInScene.questionRules.length; i++){
                    let questionRule = assetInScene.questionRules[i];
                    questionRule.sceneAssetRelationId = assetInScene.sceneAssetRelation.sceneAssetRelationId;
    
                    let findAsset = dupAssets.find((dupAsset: any) => dupAsset.originalSceneAssetRelationId == questionRule.linkedSceneAssetRelationId || dupAsset.newSceneAssetRelationId == questionRule.linkedSceneAssetRelationId);
                    if(findAsset)
                        questionRule.linkedSceneAssetRelationId = findAsset.sceneAssetRelation.sceneAssetRelationId;
    
                    await this.saveService.addQuestionRuleToDbWithoutPromise(questionRule);
                }
            }
            resolve(true);
        });
    }

    deepCopyProject(project: Project) : Project{ 
        var copyProject: Project = this.deepCopyService.deepCopy(project);
        copyProject.projectId = 0;
        return copyProject;
    }
    
    deepCopyScene(scene): Scene{        
        var sceneForDb: Scene = this.deepCopyService.deepCopy(scene);
        sceneForDb.sceneId = 0;
    
        if(sceneForDb.events){
            sceneForDb.events.forEach(event => {
                event.vrEventId = 0;
            });
        }else{
            sceneForDb.events = [];
        }

        if(sceneForDb.outcomeActions){
            sceneForDb.outcomeActions.forEach(outcomeAction => {
                outcomeAction.outcomeActionId = 0;
            });
        }else{
            sceneForDb.outcomeActions = [];
        }

        console.log(sceneForDb);
        return sceneForDb;
    }

    deepCopyAsset(assetInScene: AssetInScene, newSceneId: number, assetsInScene: AssetInScene[]): AssetInScene{
        var responseAssetsCount = 0;
        var assetForScene: AssetInScene = this.deepCopyService.deepCopy(assetInScene);
        assetForScene.baseAsset.baseAssetId = 0;
        assetForScene.sceneAssetRelation.sceneId = newSceneId;
        assetForScene.sceneAssetRelation.sceneAssetRelationId = this.getMaxSceneAssetRelationId(assetsInScene) + 1;
        assetForScene.expanded = false;
        assetForScene.toBeRemoved = false;

        if((assetForScene.baseAsset as any).responses && (assetForScene.baseAsset as any).responses.length > 0){
            (assetForScene.baseAsset as any).responses.forEach(response => {
                response.questionAssetId = 0;
                response.questionResponseId = 0;
                var assetsInResponses: AssetInScene[] = [];
                response.assets.forEach((assetInResponse, index) => {
                    var assetInResponseCopy = this.deepCopyAsset(assetInResponse, newSceneId, assetsInScene);
                    assetInResponseCopy.sceneAssetRelation.sceneAssetRelationId = assetInResponseCopy.sceneAssetRelation.sceneAssetRelationId + index + 1;
                    responseAssetsCount++;
                    assetsInResponses.push(assetInResponseCopy);
                });
                response.assets = assetsInResponses;
            });            
        }
    
        assetForScene.events = assetForScene.events ? assetForScene.events : [];        
        assetForScene.events.forEach(event => {
            var originalEvent = assetInScene.events.filter(e => e.vrEventId == event.vrEventId)[0];
            if(originalEvent.linkedContentId == originalEvent.sceneAssetRelationId){
                // If the asset performs the event on itself, so should the duplicate:
                event.linkedContentId = assetForScene.sceneAssetRelation.sceneAssetRelationId;
            }
            event.vrEventId = 0;
            event.sceneAssetRelationId = assetForScene.sceneAssetRelation.sceneAssetRelationId;
        });
    
        assetForScene.questionRules = assetForScene.questionRules ? assetForScene.questionRules : [];
        assetForScene.questionRules.forEach(questionRule => {
            questionRule.linkedSceneAssetRelationId = assetForScene.sceneAssetRelation.sceneAssetRelationId;
            questionRule.questionRuleId = 0;
            questionRule.sceneAssetRelationId = assetForScene.sceneAssetRelation.sceneAssetRelationId;
        });

        assetForScene.outcomeActions = assetForScene.outcomeActions ? assetForScene.outcomeActions : [];
        assetForScene.outcomeActions.forEach(outcomeAction => {
            outcomeAction.sceneAssetRelationId = assetForScene.sceneAssetRelation.sceneAssetRelationId;
            outcomeAction.outcomeActionId = 0;
        });

        var assetsInAssetForScene: AssetInScene[] = [];
        assetForScene.assets.forEach((assetInAsset, index) => {
            var assetInAssetForScene = this.deepCopyAsset(assetInAsset, newSceneId, assetsInScene);
            assetInAssetForScene.sceneAssetRelation.sceneAssetRelationId = assetInAssetForScene.sceneAssetRelation.sceneAssetRelationId + responseAssetsCount + index + 1;
            assetsInAssetForScene.push(assetInAssetForScene);
        });
        assetForScene.assets = assetsInAssetForScene;
        
        return assetForScene;
    }

    getMaxSceneAssetRelationId(assetsInScene) {
        var max = 0;
        assetsInScene.forEach(assetInScene => {
        let assetType = this.assetTypeService.getType(assetInScene.baseAsset.assetTypeId);
        if (assetInScene.sceneAssetRelation.sceneAssetRelationId > max) {
            max = assetInScene.sceneAssetRelation.sceneAssetRelationId;
        }
        if(assetType == 'Question'){
            let questionAsset = assetInScene.baseAsset as QuestionAsset;
            questionAsset.responses.forEach(r => {
            if(!r.assets) return;

            r.assets.forEach(assetInQuestionResponse => {
                if (assetInQuestionResponse.sceneAssetRelation.sceneAssetRelationId > max) {
                max = assetInQuestionResponse.sceneAssetRelation.sceneAssetRelationId;
                }
            });
            });
        }
        assetInScene.assets.forEach(assetInAsset => {
            let assetInAssetType = this.assetTypeService.getType(assetInAsset.baseAsset.assetTypeId);
            if (assetInAsset.sceneAssetRelation.sceneAssetRelationId > max) {
            max = assetInAsset.sceneAssetRelation.sceneAssetRelationId;
            }
            if(assetInAssetType == 'Question'){
            let questionAssetInAsset = assetInAsset.baseAsset as QuestionAsset;
            questionAssetInAsset.responses.forEach(r => {
                if(!r.assets) return;

                r.assets.forEach(assetInQuestionResponse => {
                if (assetInQuestionResponse.sceneAssetRelation.sceneAssetRelationId > max) {
                    max = assetInQuestionResponse.sceneAssetRelation.sceneAssetRelationId;
                }
                });
            });
            }
        });
        })
        return max;
    }

    getIds(array, param): number[] {
        var ids: number[] = [];
        array.forEach(element => {
            ids.push(element[param]);
        })
        return ids;
    }

    copyName(name: string, objectArrayToCompare: any[], maxLength: number = 40): string{
        var counter = 0;
        var counterStringLength = 0;
        var compareName = name.substring(0,maxLength - counterStringLength);
        objectArrayToCompare.forEach(object => {
            counterStringLength = (`(${counter + 1})`).length;
            if(object.name == compareName){
                counter++;
                compareName = `${name.substring(0,maxLength - counterStringLength)}(${counter})`;
            }
        });
        name = compareName;
        return name;
    }

    revertAssetFromAsset(assetToRevert: AssetInScene, assetData: AssetInScene){
        // BaseAsset
        for(let k in assetToRevert.baseAsset){
            assetToRevert.baseAsset[k] = assetData[k];
        }

        // SceneAssetRelation
        for(let k in assetToRevert.sceneAssetRelation){
            assetToRevert.sceneAssetRelation[k] = assetData[k];
        }

        assetToRevert.events = assetData.events;
        assetToRevert.questionRules = assetData.questionRules;
        assetToRevert.outcomeActions = assetData.outcomeActions;
        assetToRevert.assets = assetData.assets;
        assetToRevert.expanded = assetData.expanded;
        assetToRevert.toBeRemoved = assetData.toBeRemoved;
        
    }   
}